import React, { useState } from "react";
import "./header.css";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

const Header = ({ onMenuToggle }) => {
  const first_name = useSelector((state) => state?.auth?.user?.first_name);

  return (
    <header>
      <div className="dashHead">
        <div className="logo">
          <img src="../images/logo-new.png" className="img-fluid" alt="logo" />
          <div
            className="sidebarmenu"
            onClick={onMenuToggle} // ✅ toggle sidebar
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>

        <div className="dashRight">
          <div className="profileArea">
            <div className="profileBell">
              <Link to={"/profile"} className="profileInitial">
                {first_name?.[0]?.toUpperCase() || "U"}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
